import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const PrivacyPage = () => {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg-main)', paddingTop: '80px' }}>
      <section style={{ padding: '3rem 1.2rem 2rem', background: 'var(--gradient-hero)', textAlign: 'center' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <Link to="/" className="body-small" style={{ textDecoration: 'none', color: 'var(--text-secondary)', display: 'inline-flex', alignItems: 'center', gap: '0.5rem', marginBottom: '2rem' }}>
            <ArrowLeft size={16} /> Retour
          </Link>
          <h1 className="heading-hero" style={{ marginBottom: '1rem' }}>Politique de Confidentialité</h1>
        </div>
      </section>

      <section style={{ padding: '3rem 1.2rem' }}>
        <div className="container" style={{ maxWidth: '800px' }}>
          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>1. Responsable du traitement</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Le responsable du traitement des données personnelles est :<br />
              <strong>APDR de la VAE</strong><br />
              SIREN : 833 761 133<br />
              Email : <a href="mailto:apdr.vae@gmail.com">apdr.vae@gmail.com</a><br />
              Téléphone : 06 88 39 96 24
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>2. Données collectées</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Dans le cadre de l'utilisation de la plateforme, nous collectons les données suivantes :<br /><br />
              - <strong>Données d'identification :</strong> nom, prénom, adresse email<br />
              - <strong>Données de connexion :</strong> identifiants, mot de passe (chiffré)<br />
              - <strong>Données de navigation :</strong> progression dans les cours, activités complétées<br />
              - <strong>Données de paiement :</strong> traitées directement par Stripe (nous ne stockons pas vos données bancaires)<br />
              - <strong>Données d'accompagnement :</strong> rendez-vous, corrections, suivi pédagogique
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>3. Finalités du traitement</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Vos données personnelles sont collectées pour les finalités suivantes :<br /><br />
              - Gestion de votre compte utilisateur et accès à la plateforme<br />
              - Fourniture des services d'accompagnement VAE<br />
              - Suivi de votre progression pédagogique<br />
              - Gestion des rendez-vous et de la facturation<br />
              - Communication relative à votre accompagnement (notifications, rappels)<br />
              - Amélioration de nos services
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>4. Base légale du traitement</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Le traitement de vos données repose sur :<br /><br />
              - <strong>L'exécution du contrat</strong> lié à votre inscription et à l'achat d'une formule<br />
              - <strong>Votre consentement</strong> pour les communications non essentielles<br />
              - <strong>L'intérêt légitime</strong> pour l'amélioration de nos services
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>5. Durée de conservation</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Vos données personnelles sont conservées pendant la durée de votre inscription sur la plateforme et pendant une durée de 3 ans après votre dernière connexion, conformément à la réglementation en vigueur.<br /><br />
              Les données de facturation sont conservées pendant la durée légale de 10 ans.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>6. Vos droits</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Conformément au RGPD, vous disposez des droits suivants :<br /><br />
              - <strong>Droit d'accès :</strong> obtenir une copie de vos données personnelles<br />
              - <strong>Droit de rectification :</strong> corriger des données inexactes<br />
              - <strong>Droit à l'effacement :</strong> demander la suppression de vos données<br />
              - <strong>Droit à la portabilité :</strong> recevoir vos données dans un format structuré<br />
              - <strong>Droit d'opposition :</strong> vous opposer au traitement de vos données<br /><br />
              Pour exercer vos droits, contactez-nous à : <a href="mailto:apdr.vae@gmail.com">apdr.vae@gmail.com</a>
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>7. Sécurité des données</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Nous mettons en place des mesures techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, perte ou altération. Les mots de passe sont chiffrés et les paiements sont traités via la plateforme sécurisée Stripe.
            </p>
          </div>

          <div className="card" style={{ padding: '2rem', marginBottom: '2rem' }}>
            <h2 className="heading-2" style={{ marginBottom: '1rem' }}>8. Contact</h2>
            <p className="body-medium" style={{ lineHeight: 1.8, color: 'var(--text-secondary)' }}>
              Pour toute question concernant notre politique de confidentialité ou le traitement de vos données personnelles :<br /><br />
              Email : <a href="mailto:apdr.vae@gmail.com">apdr.vae@gmail.com</a><br />
              Téléphone : 06 88 39 96 24
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPage;
